<script>
import { BModal, BFormGroup, BFormInput, BFormCheckbox } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import {getAllSubstanceLists} from "@core/domain/substance";
import InstructionText from "@core/components/common/instructions/InstructionText.vue";
import Overlay from "@core/components/common/Overlay.vue";
import {SubstanceApi} from "@core/api";
import backendResponse from "@core/mixins/ui/backend-response";
import AddSubstanceForm from "@/views/product/components/product-card/AddSubstanceForm.vue";

export default {
    mixins: [backendResponse],
    props: {
        title: {
            type: String,
            default() {
                return this.$t('Component(AddSubstanceModal):label')
            },
        },
        showLists: {
            type: Boolean,
            default: false
        },
        parentSubstanceId: {
            type: Object,
            default: null,
        },
        substanceLists: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    components: {
        AddSubstanceForm,
        Overlay, InstructionText, BModal, BFormGroup, BFormInput, AppCollapse, AppCollapseItem, BFormCheckbox},
    data() {
        return {
            substance: {
                name: '',
                ec: '',
                cas: '',
            },
            legislations: [],
            showLoading: false,
            saving: false
        };
    },
    methods: {
        onSave(e) {
            e.preventDefault();

            this.saving = true;
            this.showLoading = true;

            SubstanceApi
            .addUserSubstance(this.substance)
            .then(r => {
                this.$emit('created', {...r.data});

                this.$refs.modal.hide();
                this.$refs.substanceForm.clear();
            })
            .catch(this.handleBackendError)
            .finally(() => {
                this.showLoading = false;
                this.saving = false; // todo needs to be removed
            })
        },
        show() {
            this.$refs.modal.show();
        },
        clear() {
            this.legislations.forEach(l => l.include = false);
        },
        onSubstanceChange(substance) {
            this.substance.ec = substance.ec;
            this.substance.cas = substance.cas;
            this.substance.name = substance.name;
        }
    },
    computed: {
        isFirstStepDone() {
            return this.substance.name && (this.substance.ec || this.substance.cas);
        },
        firstStepClass() {
            return this.isFirstStepDone ? 'done' : '';
        },
        isSecondStepDone() {
            return this.legislations.findIndex(l => l.include) >= 0;
        },
        secondStepClass() {
            return this.isSecondStepDone ? 'done' : '';
        },
        isOkDisabled() {
            if (this.saving) {
                return true;
            }
            if (!this.isFirstStepDone) {
                return true;
            }
            return this.showLists && !this.isSecondStepDone;
        }
    },
    created() {
        if (this.showLists) {
            getAllSubstanceLists().then(lists => {
                lists.filter(l => l.allowNewSubstances()).forEach(list => {
                    this.legislations.push({
                        include: false,
                        list: list.toDTO()
                    });
                });
            });
        }
    }
}
</script>

<template>
    <b-modal
        ref="modal"
        cancel-variant="outline-secondary"
        ok-title="Save"
        :ok-disabled="isOkDisabled"
        @ok="onSave"
        @hidden="clear"
        size="lg"
        cancel-title="Close"
        centered
        no-close-on-backdrop
        :title="title"
    >
        <Overlay :show="showLoading">
<!--            <app-collapse-->
<!--                accordion-->
<!--                type="margin"-->
<!--                class="add-substance-modal"-->
<!--                v-if="showLists"-->
<!--            >-->
<!--                <app-collapse-item-->
<!--                    :title="$t('Component(AddSubstanceModal):step-1-label')"-->
<!--                    ref="step1"-->
<!--                    :class="firstStepClass"-->
<!--                    is-visible-->
<!--                >-->
<!--                    <AddSubstanceForm-->
<!--                        ref="substanceForm"-->
<!--                        @input="onSubstanceChange"-->
<!--                    />-->
<!--                </app-collapse-item>-->
<!--                <app-collapse-item-->
<!--                    :title="$t('Component(AddSubstanceModal):step-2-label')"-->
<!--                    ref="step2"-->
<!--                    :class="secondStepClass"-->
<!--                    :disabled="!this.isFirstStepDone"-->
<!--                >-->
<!--                    <InstructionText>{{ $t('Component(AddSubstanceModal):regulation-selection-instruction') }}</InstructionText>-->
<!--                    <b-form-checkbox-->
<!--                        v-for="container in legislations"-->
<!--                        inline-->
<!--                        :name="container.list.id + 'list'"-->
<!--                        class="mt-0 mr-50"-->
<!--                        v-model="container.include"-->
<!--                    >{{ container.list.title }}</b-form-checkbox>-->
<!--                </app-collapse-item>-->
<!--            </app-collapse>-->
            <AddSubstanceForm
                ref="substanceForm"
                @input="onSubstanceChange"
            />
        </Overlay>
    </b-modal>
</template>
<style lang="scss">
.add-substance-modal > .card {
    border: 1px solid #d5d3da !important;
}
.add-substance-modal > .card.done {
    border-color: #21b764b3 !important;

    background-position: right 3rem top 1.23rem;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2321b764b3' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-size: calc(0.725em + 0.438rem) calc(0.725em + 0.438rem);
}
</style>
